import { Version } from '@/interfaces/Game'

interface IUseGame {
  name: string
}

const games: { [key in Version]: IUseGame; } = {
  1: {
    name: 'Квартира'
  },
  2: {
    name: 'Дом'
  },
  3: {
    name: 'Квартал'
  },
  4: {
    name: 'Чистый город'
  },
  5: {
    name: 'Урбанистика'
  }
}

const useGame = (version: Version): IUseGame => {
  return games[version]
}

export default useGame
